import { FC, useEffect } from "react";
import Services from "../../../components/Booking-clientSide/appointment/Services";
import ServicesSideBar from "../../../components/Booking-clientSide/appointment/ServicesSideBar";
import AppointmentDatePicker from "../../../components/Booking-clientSide/appointment/AppointmentDatePicker";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

interface BookingAppointmentPickDateProps {}

const BookingAppointmentPickDate: FC<
  BookingAppointmentPickDateProps
> = ({}) => {
  const { client } = useSelector(
    (state: {
      cart: {
        client: {
          phoneNumber: string | null;
          token: string | null;
        };
      };
    }) => {
      return {
        client: state.cart.client,
      };
    }
  );

  if (!client?.token) {
    return null;
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 max-h-[100vh] p-1 overflow-y-auto">
      <div className="col-span-1 md:col-span-2 ">
        <AppointmentDatePicker />
      </div>
      <div className="col-span-1  ">
        {" "}
        <ServicesSideBar />
      </div>
    </div>
  );
};

export default BookingAppointmentPickDate;
